import React from 'react'
import AutographSignatureReplicasView from '../../views/autograph-signature-replicas/autograph-signature-replicas.view'
import { LocalStorageService } from '../../../services/index'


class AutographSignatureReplicas extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
  }

  token = {}
  url = process.env.REACT_APP_MIFIRMA_API
  localStorageService = new LocalStorageService()


  async componentDidMount() {
    // this.setState({ loading: true })
    this.token = this.localStorageService.getLocalStorageItem('token').idToken

  }

  scrollWindow = () => {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <AutographSignatureReplicasView
        {...this.state}
      />
    )
  }
}

export { AutographSignatureReplicas as default }


// import React, { useState, useEffect } from 'react'
// import { AutographSignatureReplicasView } from '../../views'
// import { LocalStorageService } from '../../../services/index'

// export default function AutographSignatureReplicasAction() {
//   const [loading, setLoading] = useState(false)
//   const [url, seturl] = useState(null)
//   const [token, settoken] = useState({})
//   const [localStorageService, setlocalStorageService] = useState(new LocalStorageService())
//   const scrollWindow = () => {
//     window.scrollTo(0, 0)
//   }
//   useEffect(() => {
//     seturl(process.env.REACT_APP_MIFIRMA_API)
//     setlocalStorageService(new LocalStorageService())
//     settoken(localStorageService.getLocalStorageItem('token').idToken)
//   }, [])
//   return (
//     <AutographSignatureReplicasView
//       loading={loading}
//       setLoading={setLoading}
//       url={url}
//       token={token}
//       scrollWindow={scrollWindow}
//     />
//   )
// }

